import { mapActions, mapState } from 'vuex';

import { MenuListItem } from '@/components';
import {
  MENU_TABS,
  MENU_TAB_KEYS,
  SNACKBAR_TYPES,
} from '@/utils/constants';

export default {
  name: 'MenuList',
  components: {
    MenuListItem,
  },
  data() {
    return {
      activeTab: MENU_TABS.ALL,
      notificationRemoved: false,
      tabs: ['全部', '未參與', '已參與', '即將開始'],
    };
  },
  computed: {
    ...mapState('menu', {
      formattedMenu: ({ formattedMenu }) => formattedMenu,
      gettingMenuList: ({ gettingMenuList }) => gettingMenuList,
    }),
    ...mapState('user', {
      user: ({ user }) => user,
    }),
  },
  async created() {
    try {
      await Promise.all([
        this.getMenuList(MENU_TAB_KEYS[this.activeTab]),
        this.getUser(),
      ]);
    } catch (error) {
      const { message: msg } = error;
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        msg,
      });
    }
  },
  methods: {
    ...mapActions('menu', {
      getMenuList: 'GET_MENU_LIST',
    }),
    ...mapActions('user', {
      getUser: 'GET_USER',
    }),
    toUserInfo() {
      this.$router.push('/user');
    },
    removeNotification(e) {
      e.preventDefault();
      this.notificationRemoved = true;
      localStorage.setItem('hideNotification', true);
    },
  },
  watch: {
    async activeTab(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      try {
        await this.getMenuList(MENU_TAB_KEYS[newValue]);
      } catch (error) {
        const { message: msg } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          msg,
        });
      }
    },
  },
};
